import React from 'react';



type Props = {
  className?: string;
}
export const ArrowRightVector: React.FC<Props> = ({ className }) => {
  return (
    <svg className = { className } width = '16' height = '16' viewBox = '0 0 16 16' fill = 'none' xmlns = 'http://www.w3.org/2000/svg'>
      <path stroke = 'currentColor' strokeWidth = '2' d = 'M5 2L11 7L11 9L5 14' />
    </svg>
  );
};
